// VanJS Feather - ArrowUp
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const ArrowUp = (props: Partial<SVGProps> = {}) => {
  const { line, polyline } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    line({
      x1: "12",
      y1: "19",
      x2: "12",
      y2: "5",
    }),
    polyline({ points: "5 12 12 5 19 12" }),
  );
};
